import React from 'react';
import styled from 'styled-components';
import { Button, SanityImage } from 'components';
import { motion } from 'framer-motion';

function CartPreviewDropdown({ cartCounter, quote, setShowCartPreview }) {
  return (
    <Container tabIndex={0}>
      <div>
        <div>
          <h4>
            My Quote,{' '}
            <span>
              {cartCounter} item{cartCounter > 1 ? 's' : ''}
            </span>
          </h4>
        </div>
        <QuoteItems quoteLength={quote.length}>
          {quote.map((item) => (
            <QuoteItem key={item.productId} tabIndex={0}>
              <StyledSanityImage
                image={item.image}
                imageWidth={121}
                imageHeight={154}
                alt={item.title}
                title={item.title}
              />
              <ItemDetails>
                <h4>{item.title}</h4>
                <p>Size: {item.dimensions.label}</p>
                <p>Quantity: {item.quantity}</p>
              </ItemDetails>
            </QuoteItem>
          ))}
        </QuoteItems>
      </div>
      <div>
        <div />
        <Button
          to="/request-a-quote/"
          onClick={() => setShowCartPreview(false)}
          style={{ width: '145px' }}>
          View Quote
        </Button>
      </div>
    </Container>
  );
}

const Container = styled(motion.div).attrs({
  initial: {
    opacity: 0,
    y: 0,
    height: 0
  },
  animate: {
    opacity: 1,
    y: 475,
    height: 475
  },
  exit: {
    opacity: 0,
    y: 475,
    height: 475
  },
  transition: {
    type: 'tween',
    ease: 'easeInOut',
    duration: 0.5
  }
})`
  align-items: center;
  background-color: rgb(245 245 245 / 100%);
  border-radius: 0.375rem;
  border: 0.063rem solid #c4c4c4;
  bottom: 0.063rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: hidden;
  position: absolute;
  right: 9.375rem;
  width: 21.25rem;
  z-index: -1 !important;

  > div:nth-of-type(1) {
    width: 100%;

    > div {
      align-items: center;
      background-color: #d9d9d9;
      display: flex;
      height: 80px;
      padding: 0 1rem;
      width: 100%;

      h4 {
        font-size: 1.125rem;
        text-transform: uppercase;

        span {
          font-weight: 400;
          text-transform: lowercase;
        }
      }
    }
  }

  > div:nth-of-type(2) {
    padding: 0 1rem;
    width: 100%;

    > div {
      border-top: 0.063rem solid #c4c4c4;
    }

    a {
      display: block;
      margin: 9px auto;
      text-align: center;
    }
  }
`;

const QuoteItems = styled.ul`
  height: 328px;
  overflow-y: ${({ quoteLength }) => (quoteLength > 1 ? 'scroll' : 'auto')};
  padding: 1.25rem 1rem 0 1.25rem;
`;

const QuoteItem = styled.li`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.25rem;
  width: 100%;
`;

const ItemDetails = styled.div`
  h4 {
    font-size: 18px;
  }
`;

const StyledSanityImage = styled(SanityImage)`
  border-radius: 0.375rem;
  flex-shrink: 0;
  height: 9.625rem;
  width: 7.563rem;
`;

export default CartPreviewDropdown;
